<script>
	import { onAuthStateChanged } from "firebase/auth";

	import Navbar from "./Navbar.svelte";
	import MainContent from "./MainContent.svelte";
	import DataVisualizations from "./DataViz/DataVisualizations.svelte";
	import Footer from "./Footer.svelte";

	import { Route, Router } from "svelte-routing";
	import { userHasPremium, userLoggedIn } from "./Stores";
	import Login from "./Auth/Login.svelte";
	import Register from "./Auth/Register.svelte";
	import RecoverPassword from "./Auth/RecoverPassword.svelte";
	import { premiumRole } from "./Constants";

	export let auth;
	export let firestore;
	export let firebaseApp;

	let appName = "VagasInternato";

	onAuthStateChanged(auth, async (user) => {
		if (user) {
			$userLoggedIn = true;
			await auth.currentUser.getIdToken(true);
			const decodedToken = await auth.currentUser.getIdTokenResult();
			//$userHasPremium = decodedToken.claims.stripeRole === premiumRole;
		} else {
			$userLoggedIn = false;
			//$userHasPremium = false;
		}
	});
</script>

<Router>
	<main class=" bg-slate-100">
		<div class="mx-5 py-5">
			<Navbar {appName} {auth} {firestore} {firebaseApp} />

			<Route path="/">
				<MainContent {appName} {auth} {firestore} />
			</Route>
			<Route path="/data-visualizations">
				<DataVisualizations {auth} />
			</Route>
			<Route path="/login">
				<Login {auth} {firestore} />
			</Route>
			<Route path="/register">
				<Register {auth} />
			</Route>
			<Route path="/recover-password">
				<RecoverPassword {auth} />
			</Route>
			<Footer />
		</div>
	</main>
</Router>
